import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-b2d42262"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "color-select" }
const _hoisted_2 = ["onClick"]

import { ref } from 'vue';

interface IProps {
    list: any[]
}

export default /*#__PURE__*/_defineComponent({
  props: {
    list: { default: () => [] }
  },
  emits: ["updateIndex"],
  setup(__props: any, { emit: emits }: { emit: ({
    (e: 'updateIndex', index: number): void
}), expose: any, slots: any, attrs: any }) {

const props = __props as { list: any[] }




const select = ref(0);

const click = (index: number) => {
    select.value = index
    emits('updateIndex', index)
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.list, (item, index) => {
      return (_openBlock(), _createElementBlock("div", {
        class: _normalizeClass(["color", select.value == index ? 'select-item' : ''])
      }, [
        _createElementVNode("div", {
          class: "color-item",
          style: _normalizeStyle({
                background: `url(${item})`,
                backgroundSize: '100% 100%'
            }),
          onClick: ($event: any) => (click(index))
        }, null, 12, _hoisted_2)
      ], 2))
    }), 256))
  ]))
}
}

})